export default __webpack_public_path__ + "static/media/Landing2.2aa61153.png";